import { render } from "./FamousComp.vue?vue&type=template&id=2413ee33&scoped=true"
import script from "./FamousComp.vue?vue&type=script&lang=js"
export * from "./FamousComp.vue?vue&type=script&lang=js"

import "./FamousComp.vue?vue&type=style&index=0&id=2413ee33&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2413ee33"]])

export default __exports__